import { render, staticRenderFns } from "./EditReceivedInvoice.vue?vue&type=template&id=aaa12fc4&"
import script from "./EditReceivedInvoice.vue?vue&type=script&lang=js&"
export * from "./EditReceivedInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
